export default __webpack_public_path__ + "static/media/glitch15.c4b3469b.png";